// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bey_a bhy_bj"};